import { useMutation } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
import ApiRequest from "../ApiRequest";
import { upgradeToEnterpriseSchema } from "@backend/src/schemas/paymentSchema";
import z from "zod";

type paymentUpgradeToEnterpriseResponse = ResponseType<string>;

function useUpgradeSubScriptionMutation() {
  const mutation = useMutation<
    AxiosResponseAndError<paymentUpgradeToEnterpriseResponse>["response"],
    AxiosResponseAndError<paymentUpgradeToEnterpriseResponse>["error"],
    z.infer<typeof upgradeToEnterpriseSchema>
  >({
    mutationFn: (data) =>
      ApiRequest.post<paymentUpgradeToEnterpriseResponse>(
        `${requestURLs.paymentUpgradeToEnterprise}`,
        data
      ),
  });

  return mutation;
}
export default useUpgradeSubScriptionMutation;
